import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BaaScrollContainerComponent } from '../baa-scroll-container';

@Component({
  selector: 'lib-baa-sign-success',
  standalone: true,
  imports: [CommonModule, TranslateModule, BaaScrollContainerComponent],
  templateUrl: './baa-sign-success.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BaaSignSuccessComponent {
  public readonly returnToNotes = output<void>();

  protected onReturnClick(): void {
    this.returnToNotes.emit();
  }
}
